import { z } from 'zod';

import { tlsUrl } from '@tdp/common/shared/schemas';

import { IPermissionsSchema } from './IAppAuthorization';
import { IAppDetailsActivityFeedSchema, IAppDetailsBotsSchema, IAppDetailsConfigurableTabsSchema, IAppDetailsMeetingExtensionsSchema, IAppDetailsMessagingExtensionsSchema, IAppDetailsPersonalTabsSchema } from './IAppDetailsFeatures';
import { ILocalizationInfoSchema } from './IAppDetailsLanguage';
import { IOwnersSchema } from './IAppOwners';

// TODO(nibeauli): possibly rename this as the domain objects become more clear.
export const IAppDetailsSchema = z.object({
  appId: z.string(), //TODO(nibeauli): determine if this needs to have a GUID/UUID constraint
  shortName: z.string().min(1),
  longName: z.string(),
  shortDescription: z.string().max(80),
  longDescription: z.string(),

  version: z.string(),

  developerName: z.string(),
  websiteUrl: tlsUrl.nullish(),

  // TODO(nibeauli): determine if these should be url types
  privacyUrl: tlsUrl.nullish(),
  termsOfUseUrl: tlsUrl.nullish(),

  teamsAppId: z.string(),
  mpnId: z.string().nullish(),
  userList: z.array(IOwnersSchema),
  manifestVersion: z.string().nullish(),

  // This is all sorts of wrong, this should remain as the web DTO but we should refactor our internal domain object
  // to nest this correctly
  webApplicationInfoId: z.string().nullable(),
  webApplicationInfoResource: z.string().nullable(),
  devicePermissions: z.array(z.string()).optional(),
  localizationInfo: ILocalizationInfoSchema.nullish(),
  authorization: IPermissionsSchema.optional().nullable(),
  showLoadingIndicator: z.boolean().nullish(),
  isFullScreen: z.boolean().nullish(),
  supportedChannelTypes: z.array(z.string()).nullish(),
  defaultGroupCapability: z.object({
    team: z.string().nullish(),
    groupchat: z.string().nullish(),
    meetings: z.string().nullish(),
  }).nullish(),
  configurableProperties: z.array(z.string()).nullish(),
  defaultBlockUntilAdminAction: z.boolean().nullish(),
  publisherDocsUrl: tlsUrl.nullish(),

  // App features
  staticTabs: IAppDetailsPersonalTabsSchema.array().nullish(),
  configurableTabs: IAppDetailsConfigurableTabsSchema.array().nullish(),
  meetingExtensionDefinition: IAppDetailsMeetingExtensionsSchema.nullish(),
  activities: IAppDetailsActivityFeedSchema.nullish(),
  bots: IAppDetailsBotsSchema.array().nullish(),
  messagingExtensions: IAppDetailsMessagingExtensionsSchema.array().nullish(),
  validDomains: z.array(z.string()).nullish(),

  // Branding
  accentColor: z.string().nullish(), //TODO(nibeauli): verify if this is nullish / if we should use a color parsing type
});

export type IAppDetails = z.infer<typeof IAppDetailsSchema>;
